
// SELECT id,klient_id,klient,firma_nazwa,data_spedycji,etap,przeloty_druku,przeloty_druku_zakonczone,do_wydrukowania,przeloty_falc,przeloty_falc_zakonczone,do_sfalcowania,wydrukowano_procent FROM artdruk.view_zamowienia_kalendarz;

export const rawData = [
	{
		"id" : 337,
		"klient_id" : 82,
		"klient" : "BOOKOLIKA SP. Z O.O.",
		"firma_nazwa" : "BOOKOLIKA",
		"data_spedycji" : "2026-02-27",
		"etap" : 2,
		"przeloty_druku" : 35620,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 35620,
		"przeloty_falc" : 30000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 30000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 524,
		"klient_id" : 146,
		"klient" : "BAKS Kazimierz Sielski",
		"firma_nazwa" : "BAKS",
		"data_spedycji" : "2026-03-06",
		"etap" : 2,
		"przeloty_druku" : 391145,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 391145,
		"przeloty_falc" : 350000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 350000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1153,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-02",
		"etap" : 2,
		"przeloty_druku" : 396340,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 396340,
		"przeloty_falc" : 360000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 360000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1181,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-02-23",
		"etap" : 2,
		"przeloty_druku" : 616900,
		"przeloty_druku_zakonczone" : 194950,
		"do_wydrukowania" : 421950,
		"przeloty_falc" : 600000,
		"przeloty_falc_zakonczone" : 25000,
		"do_sfalcowania" : 575000,
		"wydrukowano_procent" : 32
	},
	{
		"id" : 1232,
		"klient_id" : 75,
		"klient" : "PRÓSZYŃSKI MEDIA sp. z o.o.",
		"firma_nazwa" : "PRÓSZYŃSKI",
		"data_spedycji" : "2026-02-23",
		"etap" : 2,
		"przeloty_druku" : 47182,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 47182,
		"przeloty_falc" : 42135,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 42135,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1255,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-13",
		"etap" : 2,
		"przeloty_druku" : 12220,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 12220,
		"przeloty_falc" : 9600,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 9600,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1258,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-17",
		"etap" : 2,
		"przeloty_druku" : 31810,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 31810,
		"przeloty_falc" : 26500,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 26500,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1259,
		"klient_id" : 69,
		"klient" : "AVT- Korporacja Sp z o.o.",
		"firma_nazwa" : "AVT",
		"data_spedycji" : "2026-02-13",
		"etap" : 2,
		"przeloty_druku" : 7400,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 7400,
		"przeloty_falc" : 5300,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 5300,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 986,
		"klient_id" : 180,
		"klient" : "STURMER MASZYNY Sp. z o.o.",
		"firma_nazwa" : "STURMER",
		"data_spedycji" : "2026-02-17",
		"etap" : 4,
		"przeloty_druku" : 428120,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 428120,
		"przeloty_falc" : 410000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 410000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 990,
		"klient_id" : 2,
		"klient" : "Realise",
		"firma_nazwa" : "Realise",
		"data_spedycji" : "2026-02-18",
		"etap" : 4,
		"przeloty_druku" : 240350,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 240350,
		"przeloty_falc" : 234000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 234000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1167,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-04-09",
		"etap" : 4,
		"przeloty_druku" : 97560,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 97560,
		"przeloty_falc" : 89600,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 89600,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1178,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-02-24",
		"etap" : 4,
		"przeloty_druku" : 154250,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 154250,
		"przeloty_falc" : 150000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 150000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1231,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-02-19",
		"etap" : 4,
		"przeloty_druku" : 539050,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 539050,
		"przeloty_falc" : 525000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 525000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1254,
		"klient_id" : 206,
		"klient" : "Teatr im. St. I. Witkiewicza",
		"firma_nazwa" : "TEATR WITKIEWICZA",
		"data_spedycji" : "2026-02-20",
		"etap" : 4,
		"przeloty_druku" : 4475,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 4475,
		"przeloty_falc" : 3000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 3000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1245,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-18",
		"etap" : 5,
		"przeloty_druku" : 69940,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 69940,
		"przeloty_falc" : 65000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 65000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1197,
		"klient_id" : 148,
		"klient" : "Agencja Wydawnicza Tomczak Grzegorz",
		"firma_nazwa" : " Tomczak",
		"data_spedycji" : "2026-02-16",
		"etap" : 6,
		"przeloty_druku" : 7520,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 7520,
		"przeloty_falc" : 4800,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 4800,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1216,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-19",
		"etap" : 6,
		"przeloty_druku" : 61290,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 61290,
		"przeloty_falc" : 61000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 61000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1220,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-19",
		"etap" : 6,
		"przeloty_druku" : 159900,
		"przeloty_druku_zakonczone" : 61620,
		"do_wydrukowania" : 98280,
		"przeloty_falc" : 145000,
		"przeloty_falc_zakonczone" : 25000,
		"do_sfalcowania" : 120000,
		"wydrukowano_procent" : 39
	},
	{
		"id" : 1222,
		"klient_id" : 202,
		"klient" : "H2 Dystrybucja sp zoo",
		"firma_nazwa" : "H2",
		"data_spedycji" : "2026-02-12",
		"etap" : 6,
		"przeloty_druku" : 153310,
		"przeloty_druku_zakonczone" : 83040,
		"do_wydrukowania" : 70270,
		"przeloty_falc" : 137750,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 137750,
		"wydrukowano_procent" : 55
	},
	{
		"id" : 1226,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-13",
		"etap" : 6,
		"przeloty_druku" : 45280,
		"przeloty_druku_zakonczone" : 7060,
		"do_wydrukowania" : 38220,
		"przeloty_falc" : 40000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 40000,
		"wydrukowano_procent" : 16
	},
	{
		"id" : 1234,
		"klient_id" : 71,
		"klient" : "Stowarzyszenie Filmowców Polskich",
		"firma_nazwa" : "SFP",
		"data_spedycji" : "2026-02-13",
		"etap" : 6,
		"przeloty_druku" : 14320,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 14320,
		"przeloty_falc" : 13200,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 13200,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1240,
		"klient_id" : 51,
		"klient" : "VFP Communications Ltd. Sp. z o. o.",
		"firma_nazwa" : "VFP",
		"data_spedycji" : "2026-02-13",
		"etap" : 6,
		"przeloty_druku" : 174010,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 174010,
		"przeloty_falc" : 160000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 160000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1242,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-12",
		"etap" : 6,
		"przeloty_druku" : 20710,
		"przeloty_druku_zakonczone" : 19710,
		"do_wydrukowania" : 1000,
		"przeloty_falc" : 18900,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 18900,
		"wydrukowano_procent" : 96
	},
	{
		"id" : 1244,
		"klient_id" : 99,
		"klient" : "INTER-TEAM Sp. z o.o.",
		"firma_nazwa" : "INTER-TEAM",
		"data_spedycji" : "2026-02-11",
		"etap" : 6,
		"przeloty_druku" : 10390,
		"przeloty_druku_zakonczone" : 9090,
		"do_wydrukowania" : 1300,
		"przeloty_falc" : 10000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 10000,
		"wydrukowano_procent" : 88
	},
	{
		"id" : 1248,
		"klient_id" : 118,
		"klient" : "Solmedia Urszula Kaszubowska",
		"firma_nazwa" : "Solmedia",
		"data_spedycji" : "2026-02-12",
		"etap" : 6,
		"przeloty_druku" : 20050,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 20050,
		"przeloty_falc" : 16800,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 16800,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1257,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-13",
		"etap" : 6,
		"przeloty_druku" : 10420,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 10420,
		"przeloty_falc" : 8800,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 8800,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1154,
		"klient_id" : 194,
		"klient" : "VPRINT",
		"firma_nazwa" : "VPRINT",
		"data_spedycji" : "2026-01-29",
		"etap" : 8,
		"przeloty_druku" : 96200,
		"przeloty_druku_zakonczone" : 96200,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 0,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1179,
		"klient_id" : 159,
		"klient" : "Miłosz Łuniewski",
		"firma_nazwa" : "Miłosz Łuniewski",
		"data_spedycji" : "2026-01-22",
		"etap" : 8,
		"przeloty_druku" : 6800,
		"przeloty_druku_zakonczone" : 6800,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 0,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1180,
		"klient_id" : 201,
		"klient" : "PANORAMA",
		"firma_nazwa" : "PANORAMA",
		"data_spedycji" : "2026-01-26",
		"etap" : 8,
		"przeloty_druku" : 700,
		"przeloty_druku_zakonczone" : 700,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 0,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1207,
		"klient_id" : 48,
		"klient" : "Instytut Zarządzania Informacją Sp. zoo",
		"firma_nazwa" : "IZI",
		"data_spedycji" : "2026-02-13",
		"etap" : 8,
		"przeloty_druku" : 67720,
		"przeloty_druku_zakonczone" : 67720,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 60890,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 60890,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1221,
		"klient_id" : 80,
		"klient" : "Wydawnictwa Komunikacji i Łączności ",
		"firma_nazwa" : "WKL",
		"data_spedycji" : "2026-02-12",
		"etap" : 8,
		"przeloty_druku" : 11680,
		"przeloty_druku_zakonczone" : 11680,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 9000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 9000,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1223,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-13",
		"etap" : 8,
		"przeloty_druku" : 62140,
		"przeloty_druku_zakonczone" : 62140,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 77000,
		"przeloty_falc_zakonczone" : 46200,
		"do_sfalcowania" : 30800,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1225,
		"klient_id" : 82,
		"klient" : "BOOKOLIKA SP. Z O.O.",
		"firma_nazwa" : "BOOKOLIKA",
		"data_spedycji" : "2026-02-06",
		"etap" : 8,
		"przeloty_druku" : 19420,
		"przeloty_druku_zakonczone" : 19420,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 20000,
		"przeloty_falc_zakonczone" : 15000,
		"do_sfalcowania" : 5000,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1238,
		"klient_id" : 44,
		"klient" : "Fischer Trading Group Sp. z o.o.",
		"firma_nazwa" : "Fischer Trading",
		"data_spedycji" : "2026-02-10",
		"etap" : 8,
		"przeloty_druku" : 481950,
		"przeloty_druku_zakonczone" : 481950,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 459000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 459000,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1241,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-11",
		"etap" : 8,
		"przeloty_druku" : 17660,
		"przeloty_druku_zakonczone" : 17660,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 15500,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 15500,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1246,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-12",
		"etap" : 8,
		"przeloty_druku" : 7590,
		"przeloty_druku_zakonczone" : 7590,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 5400,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 5400,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1087,
		"klient_id" : 194,
		"klient" : "VPRINT",
		"firma_nazwa" : "VPRINT",
		"data_spedycji" : "2026-01-23",
		"etap" : 10,
		"przeloty_druku" : 276120,
		"przeloty_druku_zakonczone" : 276120,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 1075000,
		"przeloty_falc_zakonczone" : 1075000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1121,
		"klient_id" : 55,
		"klient" : "AgroHorti Media Sp. z o.o.",
		"firma_nazwa" : "AgroHorti",
		"data_spedycji" : "2026-01-19",
		"etap" : 10,
		"przeloty_druku" : 23810,
		"przeloty_druku_zakonczone" : 23810,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 22000,
		"przeloty_falc_zakonczone" : 22000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1123,
		"klient_id" : 57,
		"klient" : "Macmillan Polska Sp. z o.o.",
		"firma_nazwa" : "Macmillan",
		"data_spedycji" : "2026-02-18",
		"etap" : 10,
		"przeloty_druku" : 354380,
		"przeloty_druku_zakonczone" : 354380,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 342000,
		"przeloty_falc_zakonczone" : 342000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1132,
		"klient_id" : 157,
		"klient" : "Wydawnictwo „TALES” Krzysztof Konkel",
		"firma_nazwa" : "TALES Konkel",
		"data_spedycji" : "2026-02-02",
		"etap" : 10,
		"przeloty_druku" : 56160,
		"przeloty_druku_zakonczone" : 56160,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 50000,
		"przeloty_falc_zakonczone" : 50000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1133,
		"klient_id" : 156,
		"klient" : "Wydawnictwo „TALES” Marek Doliński",
		"firma_nazwa" : "TALES Doliński",
		"data_spedycji" : "2026-02-02",
		"etap" : 10,
		"przeloty_druku" : 56160,
		"przeloty_druku_zakonczone" : 56160,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 50000,
		"przeloty_falc_zakonczone" : 50000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1134,
		"klient_id" : 156,
		"klient" : "Wydawnictwo „TALES” Marek Doliński",
		"firma_nazwa" : "TALES Doliński",
		"data_spedycji" : "2026-02-09",
		"etap" : 10,
		"przeloty_druku" : 64480,
		"przeloty_druku_zakonczone" : 64480,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 60000,
		"przeloty_falc_zakonczone" : 60000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1135,
		"klient_id" : 157,
		"klient" : "Wydawnictwo „TALES” Krzysztof Konkel",
		"firma_nazwa" : "TALES Konkel",
		"data_spedycji" : "2026-02-09",
		"etap" : 10,
		"przeloty_druku" : 64480,
		"przeloty_druku_zakonczone" : 64480,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 60000,
		"przeloty_falc_zakonczone" : 60000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1147,
		"klient_id" : 199,
		"klient" : "300GOSPODARKA Sp. z o.o.",
		"firma_nazwa" : "300GOSPODARKA",
		"data_spedycji" : "2026-01-23",
		"etap" : 10,
		"przeloty_druku" : 9620,
		"przeloty_druku_zakonczone" : 9620,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 8000,
		"przeloty_falc_zakonczone" : 8000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1162,
		"klient_id" : 164,
		"klient" : "Polski Związek Piłki Nożnej",
		"firma_nazwa" : "PZPN",
		"data_spedycji" : "2026-01-30",
		"etap" : 10,
		"przeloty_druku" : 49920,
		"przeloty_druku_zakonczone" : 49920,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 44000,
		"przeloty_falc_zakonczone" : 44000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1164,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-16",
		"etap" : 10,
		"przeloty_druku" : 81390,
		"przeloty_druku_zakonczone" : 81390,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 74400,
		"przeloty_falc_zakonczone" : 74400,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1166,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-16",
		"etap" : 10,
		"przeloty_druku" : 37260,
		"przeloty_druku_zakonczone" : 37260,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 32400,
		"przeloty_falc_zakonczone" : 32400,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1169,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-16",
		"etap" : 10,
		"przeloty_druku" : 84200,
		"przeloty_druku_zakonczone" : 84200,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 77000,
		"przeloty_falc_zakonczone" : 77000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1186,
		"klient_id" : 80,
		"klient" : "Wydawnictwa Komunikacji i Łączności ",
		"firma_nazwa" : "WKL",
		"data_spedycji" : "2026-02-05",
		"etap" : 10,
		"przeloty_druku" : 41675,
		"przeloty_druku_zakonczone" : 41675,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 42000,
		"przeloty_falc_zakonczone" : 42000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1211,
		"klient_id" : 189,
		"klient" : "Europrint Media Andrzej Oset",
		"firma_nazwa" : "Europrint ",
		"data_spedycji" : "2026-02-13",
		"etap" : 10,
		"przeloty_druku" : 17333,
		"przeloty_druku_zakonczone" : 17333,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 17500,
		"przeloty_falc_zakonczone" : 17500,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1217,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-19",
		"etap" : 10,
		"przeloty_druku" : 116220,
		"przeloty_druku_zakonczone" : 116220,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 105000,
		"przeloty_falc_zakonczone" : 105000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1229,
		"klient_id" : 56,
		"klient" : "PrintCare Majewski Grzelak sp.k.",
		"firma_nazwa" : "PrintCare",
		"data_spedycji" : "2026-02-09",
		"etap" : 10,
		"przeloty_druku" : 2450,
		"przeloty_druku_zakonczone" : 2450,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 3000,
		"przeloty_falc_zakonczone" : 3000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1230,
		"klient_id" : 56,
		"klient" : "PrintCare Majewski Grzelak sp.k.",
		"firma_nazwa" : "PrintCare",
		"data_spedycji" : "2026-02-09",
		"etap" : 10,
		"przeloty_druku" : 2700,
		"przeloty_druku_zakonczone" : 2700,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 3000,
		"przeloty_falc_zakonczone" : 3000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1233,
		"klient_id" : 69,
		"klient" : "AVT- Korporacja Sp z o.o.",
		"firma_nazwa" : "AVT",
		"data_spedycji" : "2026-02-09",
		"etap" : 10,
		"przeloty_druku" : 21420,
		"przeloty_druku_zakonczone" : 21420,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 16560,
		"przeloty_falc_zakonczone" : 16560,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 936,
		"klient_id" : 138,
		"klient" : "PRACOWNIA C C Sp. z o.o.",
		"firma_nazwa" : "PRACOWNIA C C",
		"data_spedycji" : "2025-11-25",
		"etap" : 11,
		"przeloty_druku" : 59335,
		"przeloty_druku_zakonczone" : 59335,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 55500,
		"przeloty_falc_zakonczone" : 55500,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 974,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-08",
		"etap" : 11,
		"przeloty_druku" : 41240,
		"przeloty_druku_zakonczone" : 41240,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 36000,
		"przeloty_falc_zakonczone" : 36000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 975,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-08",
		"etap" : 11,
		"przeloty_druku" : 61340,
		"przeloty_druku_zakonczone" : 61340,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 54000,
		"przeloty_falc_zakonczone" : 54000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1003,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-08",
		"etap" : 11,
		"przeloty_druku" : 84755,
		"przeloty_druku_zakonczone" : 84755,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 75300,
		"przeloty_falc_zakonczone" : 75300,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1007,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-08",
		"etap" : 11,
		"przeloty_druku" : 84755,
		"przeloty_druku_zakonczone" : 84755,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 75300,
		"przeloty_falc_zakonczone" : 75300,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1084,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-14",
		"etap" : 11,
		"przeloty_druku" : 180060,
		"przeloty_druku_zakonczone" : 180060,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 154000,
		"przeloty_falc_zakonczone" : 154000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1088,
		"klient_id" : 194,
		"klient" : "VPRINT",
		"firma_nazwa" : "VPRINT",
		"data_spedycji" : "2026-01-23",
		"etap" : 11,
		"przeloty_druku" : 531900,
		"przeloty_druku_zakonczone" : 531900,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 2254000,
		"przeloty_falc_zakonczone" : 2254000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1089,
		"klient_id" : 194,
		"klient" : "VPRINT",
		"firma_nazwa" : "VPRINT",
		"data_spedycji" : "2026-01-23",
		"etap" : 11,
		"przeloty_druku" : 77000,
		"przeloty_druku_zakonczone" : 77000,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 315000,
		"przeloty_falc_zakonczone" : 315000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1090,
		"klient_id" : 194,
		"klient" : "VPRINT",
		"firma_nazwa" : "VPRINT",
		"data_spedycji" : "2026-01-23",
		"etap" : 11,
		"przeloty_druku" : 1160,
		"przeloty_druku_zakonczone" : 1160,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 1500,
		"przeloty_falc_zakonczone" : 1500,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1091,
		"klient_id" : 194,
		"klient" : "VPRINT",
		"firma_nazwa" : "VPRINT",
		"data_spedycji" : "2026-01-23",
		"etap" : 11,
		"przeloty_druku" : 7660,
		"przeloty_druku_zakonczone" : 7660,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 15000,
		"przeloty_falc_zakonczone" : 15000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1111,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-01-15",
		"etap" : 11,
		"przeloty_druku" : 4220,
		"przeloty_druku_zakonczone" : 4220,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 2700,
		"przeloty_falc_zakonczone" : 2700,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1117,
		"klient_id" : 69,
		"klient" : "AVT- Korporacja Sp z o.o.",
		"firma_nazwa" : "AVT",
		"data_spedycji" : "2026-01-14",
		"etap" : 11,
		"przeloty_druku" : 6220,
		"przeloty_druku_zakonczone" : 6220,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 5000,
		"przeloty_falc_zakonczone" : 5000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1155,
		"klient_id" : 194,
		"klient" : "VPRINT",
		"firma_nazwa" : "VPRINT",
		"data_spedycji" : "2026-01-30",
		"etap" : 11,
		"przeloty_druku" : 73853,
		"przeloty_druku_zakonczone" : 73853,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 87800,
		"przeloty_falc_zakonczone" : 87800,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1205,
		"klient_id" : 49,
		"klient" : "VIRIDIA AB SP.Z O.O.",
		"firma_nazwa" : "VIRIDIA",
		"data_spedycji" : "2026-02-03",
		"etap" : 11,
		"przeloty_druku" : 5960,
		"przeloty_druku_zakonczone" : 5960,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 10000,
		"przeloty_falc_zakonczone" : 10000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1237,
		"klient_id" : 55,
		"klient" : "AgroHorti Media Sp. z o.o.",
		"firma_nazwa" : "AgroHorti",
		"data_spedycji" : "2026-02-09",
		"etap" : 11,
		"przeloty_druku" : 16745,
		"przeloty_druku_zakonczone" : 16745,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 14000,
		"przeloty_falc_zakonczone" : 14000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	}
]

